import { useState } from "react";

import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import { TextField } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

interface RenameReportModalProps
  extends Omit<ConfirmationModalProps, "children" | "onConfirm"> {
  onConfirm: (title: string) => void;
  reportTitle: string;
}

const RenameReportModal = (props: RenameReportModalProps) => {
  const { _ } = useLingui();
  const [reportName, setReportName] = useState(props.reportTitle);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setReportName(e.target.value);

  return (
    <ConfirmationModal
      {...props}
      onConfirm={() => props.onConfirm(reportName)}
      confirmProps={{ label: _(msg`Rename report`) }}
      title={_(msg`Rename Meeting?`)}
      subtitle={_(
        msg`Update the name of this meeting report below. Everyone with report access can see this change.`
      )}
      size="sm"
    >
      <TextField value={reportName} onChange={handleInputChange} />
    </ConfirmationModal>
  );
};

export default RenameReportModal;
